import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";

export const CENAttributeFinalDataHandler: Handler = (props: any) => {
    props.dispatch({
        type: "Custom/ProductListCardList/AttributeFilteredData",
        data: props.parameter.data,
    });
};

export const chain = [CENAttributeFinalDataHandler];

const cenAttributeFinalDataHandler = createHandlerChainRunnerOptionalParameter(chain, {}, "CENAttributeFinalDataHandler");
export default cenAttributeFinalDataHandler;
